import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonUploadServiceSub } from 'src/app/commons/kymw00/pless-json-upload-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 産地コメント情報の取込要求を行う
 *
 * @export
 * @class UpdateProductionCenterCommentService
 * @extends {PlessJsonUploadServiceSub}
 */
@Injectable()
export class UpdateProductionCenterCommentService extends PlessJsonUploadServiceSub<any> {

  private nextFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateProductionCenterCommentService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof UpdateProductionCenterCommentService
   */
  execute(file: File, nextFunc: Function): void {
    this.nextFunc = nextFunc;
    this.sendFile('updateProductionCenterComment', this.getBody(), file);
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateProductionCenterCommentService
   */
  success(data: any) {
    this.nextFunc(data);
  }
}
